import Button from 'components/Button';
import {
	LoadingSkeleton,
	LoadingSkeletonItem,
} from 'components/LoadingSkeleton';
import { StockStatus } from 'components/Stock';

interface Props {
	buttonText?: string;
	inStock: boolean;
	isLoading?: boolean;
	onStatusClick?: () => void;
	text: string;
}

export default function StockBalanceConcise({
	buttonText,
	inStock,
	isLoading,
	onStatusClick,
	text: rawText,
}: Props) {
	if (isLoading) {
		return (
			<LoadingSkeleton>
				<LoadingSkeletonItem height="0.9rem" width="5rem" />
			</LoadingSkeleton>
		);
	}
	const text =
		!onStatusClick && !rawText.endsWith('.') ? `${rawText}.` : rawText;
	return (
		<StockStatus
			size="sm"
			inStock={inStock}
			text={
				<>
					{!onStatusClick && text}
					{onStatusClick && (
						<Button
							variant="text-inherit"
							underline={false}
							className="group/stock-btn"
							hasExpandedHitArea
							onClick={onStatusClick}
							aria-haspopup="dialog"
						>
							{text}&nbsp;
							<span className="inline-block underline group-hover/stock-btn:underline-strong">
								{buttonText}
							</span>
						</Button>
					)}
				</>
			}
		/>
	);
}
StockBalanceConcise.displayName = 'StockBalanceConcise';
